"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Tile = _interopRequireDefault(require("ol/layer/Tile"));

var _Source = _interopRequireDefault(require("ol/source/Source"));

var _XYZ = _interopRequireDefault(require("ol/source/XYZ"));

var _createLayer = _interopRequireDefault(require("./createLayer"));

var _lodash = _interopRequireDefault(require("lodash.isequal"));

var _constants = require("./constants");

var _propTypes = require("prop-types");

var _proj = require("ol/proj");

var TileLayer = (0, _createLayer["default"])({
  displayName: 'TileLayer',
  propTypes: {
    extent: _propTypes.array,
    source: _propTypes.object,
    url: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string])
  },
  componentDidMount: function componentDidMount() {
    var source = this.props.source instanceof _Source["default"] ? this.props.source : new _XYZ["default"](this.props.source);

    if (this.props.url) {
      source.setUrl(this.props.url);
    }

    this.layer = new _Tile["default"]({
      source: source,
      extent: this.getTransformedExtent(this.props.extent)
    });
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    if (!(0, _lodash["default"])(this.props.source, prevProps.source)) {
      this.layer.setSource(this.props.source instanceof _Source["default"] ? this.props.source : new _XYZ["default"](this.props.source));
    }

    if (this.props.url !== prevProps.url) {
      this.layer.getSource().setUrl(this.props.url);
    }

    if (this.props.extent !== prevProps.extent) {
      this.layer.setExtent(this.getTransformedExtent(this.props.extent));
    }
  },
  getTransformedExtent: function getTransformedExtent(extent) {
    if (!extent) {
      return undefined;
    }

    var view = this.context.map.getView();
    return (0, _proj.transformExtent)(extent, _constants.GEO_PROJECTION, view.getProjection());
  }
});
var _default = TileLayer;
exports["default"] = _default;